<style>
	.pin-input {
		padding: 10px;
    	border: 1px solid #ddd;
    	height: 50px;
    	text-align: center;
    	font-size: 30px;
	}
</style>
<template>
	<section id="setting-pin-form">
		<header class="mb-12">
			<h3 class="text-primary mb-6 text-center">
				<strong>
					Masukkan Kembali PIN Saldo Baru
				</strong>
			</h3>
			<h5 class="text-grey text-center">
				PIN Saldo digunakan untuk bertransaksi menggunakan ZAXPAY
			</h5>
		</header>
		<main class="mx-auto w-full vx-row justify-center w-full md:w-2/3 mb-12">
			<div class="vx-col w-1/6 p-0 md:p-4">
				<input type="password" class="pin-input w-full" maxlength="1" id="pin-1" ref="pin-1" @keyup="moveNextPin('pin-1', 'pin-2')" v-model="pin_1" />
			</div>
			<div class="vx-col w-1/6 p-0 md:p-4">
				<input type="password" class="pin-input w-full" maxlength="1" id="pin-2" ref="pin-2" @keyup="moveNextPin('pin-2', 'pin-3')" v-model="pin_2" />
			</div>
			<div class="vx-col w-1/6 p-0 md:p-4">
				<input type="password" class="pin-input w-full" maxlength="1" id="pin-3" ref="pin-3" @keyup="moveNextPin('pin-3', 'pin-4')" v-model="pin_3" />
			</div>
			<div class="vx-col w-1/6 p-0 md:p-4">
				<input type="password" class="pin-input w-full" maxlength="1" id="pin-4" ref="pin-4" @keyup="moveNextPin('pin-4', 'pin-5')" v-model="pin_4" />
			</div>
			<div class="vx-col w-1/6 p-0 md:p-4">
				<input type="password" class="pin-input w-full" maxlength="1" id="pin-5" ref="pin-5" @keyup="moveNextPin('pin-5', 'pin-6')" v-model="pin_5" />
			</div>
			<div class="vx-col w-1/6 p-0 md:p-4">
				<input type="password" class="pin-input w-full" v-model="pin_6" maxlength="1" id="pin-6" ref="pin-6" @keyup="moveNextPin('pin-6')" />	
			</div>
		</main>
		<div class="mx-auto w-full vx-row justify-center w-full md:w-2/3">
			<vs-button @click.prevent="createPin" :disabled="invalidPin" class="w-full rounded-lg" color="primary">
				Submit
			</vs-button>
		</div>
	</section>
</template>
<script>
	export default {
		data: () => ({
			pin_1: null,
			pin_2: null,
			pin_3: null,
			pin_4: null,
			pin_5: null,
			pin_6: null
		}),
		computed: {
			pin() {
				return this.$store.state.user.pin
			},
			invalidPin() {
				if( 
					this.pin_1 == null ||
					this.pin_1 == '' ||
					this.pin_2 == null ||
					this.pin_2 == '' ||
					this.pin_3 == null ||
					this.pin_3 == '' ||
					this.pin_4 == null ||
					this.pin_4 == '' ||
					this.pin_5 == null ||
					this.pin_5 == '' ||
					this.pin_6 == null ||
					this.pin_6 == ''
				) {
					return true
				}

				return false
			}
		},
		methods: {
			moveNextPin(id, nextFieldID = null) {
				if(this.$refs[id].value.length === 1 && nextFieldID !== null) {
					document.getElementById(nextFieldID).focus()
				}
			},
			createPin() {
				this.$vs.loading()
				setTimeout(() => {
					this.$vs.loading.close()
					const fullPin = this.pin_1 + this.pin_2 + this.pin_3 + this.pin_4 + this.pin_5 + this.pin_6
					if(fullPin.length < 6) {
						this.$vs.notify({
							title: 'Oops',
							text: 'Invalid PIN',
							color: 'danger',
							position: 'top-right'
						})

						return false
					}

					if(this.pin !== fullPin) {
						this.$vs.notify({
							title: 'Oops',
							text: 'PIN Tidak Cocok',
							color: 'danger',
							position: 'top-right'
						})

						return false	
					}

					this.$emit('confirmPin', fullPin)
				}, 500)
			}
		}
	}
</script>